import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

function useCommonParams() {
  const [searchParams] = useSearchParams();

  const queryParams = useMemo(() => {
    const offset = searchParams.get("offset");
    const search = searchParams.get("search");
    const order_direction = searchParams.get("order_direction");
    const order_by = searchParams.get("order_by");
    const limit = searchParams.get("limit");
    const is_active = searchParams.get("is_active");
    const sub_filter = searchParams.getAll("sub_filter");

    const params = {
      offset: Number(offset) || 0,
      limit: Number(limit) || 10,
    };

    // Only add non-null/non-empty values to avoid unnecessary re-renders
    if (search) {
      params.search = search;
    }

    if (order_by) {
      params.order_by = order_by;
    }

    if (order_direction) {
      params.order_direction = order_direction;
    }

    // Only include is_active when it's explicitly false (inactive filter selected)
    if (is_active === "false") {
      params.is_active = false;
    }

    if (sub_filter && sub_filter.length > 0) {
      params.sub_filter = sub_filter.map(Number);
    }

    return params;
  }, [searchParams]);

  return {
    queryParams,
  };
}

export default useCommonParams;
